import { useDispatch, useSelector } from 'react-redux';

import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { fetchLocations } from 'modules/locations/store/actions';
import { fetchOrganizer } from 'modules/organizer/store/orginizer/actions';
import { setTournamentId } from 'modules/locations/store';
import { useEffect } from 'react';
import { useOrganizer } from './use-organizer';
import { useAuth } from 'modules/auth/ui/hooks/use-auth';

export const useFetchOrganizer = () => {
  const dispatch = useDispatch();
  const tournamentId = useSelector(authStoreUserTournamentId);
  const { hasTournaments } = useAuth()
  const { isLoading, isLoaded, info } = useOrganizer();

  useEffect(() => {
    if (hasTournaments && tournamentId && !isLoading && (!isLoaded || (info && info.id !== tournamentId))) {
      dispatch(fetchOrganizer({ tournamentId }));
      dispatch(setTournamentId({ tournamentId }));
      dispatch(fetchLocations({ tournamentId }));
    }
    // Important: do not refetch organizer when only pagination params change to avoid UI flicker
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, info, isLoaded, isLoading, tournamentId, hasTournaments]);
};
